import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React, { PureComponent } from "react";
// Material Imports
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import Fade from "@material-ui/core/Grow"; // Limitless imports

import TimePosted from "../../time-posted/TimePosted";
import FadeUp from "../../animation/fade-up/FadeUp";
import { withi18n } from "../../hocs/i18n";

var CustomerDialogueWrapper = /*#__PURE__*/function (_PureComponent) {
  _inherits(CustomerDialogueWrapper, _PureComponent);

  var _super = _createSuper(CustomerDialogueWrapper);

  function CustomerDialogueWrapper() {
    var _this;

    _classCallCheck(this, CustomerDialogueWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      animate: _this.props.dialogue.created ? false : true,
      animating: _this.props.dialogue.created ? false : true,
      animationComplete: false,
      animationExited: false
    };

    _this.handleAnimationCompleted = function () {
      var newState = {
        animating: false
      };

      if (_this.props.dialogue.created) {
        newState.animationComplete = true;
      }

      _this.setState(newState);
    };

    _this.handleAnimationExit = function () {
      _this.setState({
        animationExited: true
      });
    };

    return _this;
  }

  _createClass(CustomerDialogueWrapper, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.dialogue.created && !this.state.animating) {
        this.setState({
          animationComplete: true
        });
      }

      if (nextProps.dialogue.created && !this.props.shouldAnimate) {
        this.setState({
          animationExited: true,
          animate: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var created = this.props.dialogue.created;
      var _this$props = this.props,
          t = _this$props.t,
          classes = _this$props.classes,
          shouldAnimate = _this$props.shouldAnimate,
          children = _this$props.children;
      var _this$state = this.state,
          animate = _this$state.animate,
          animationComplete = _this$state.animationComplete,
          animationExited = _this$state.animationExited;
      return /*#__PURE__*/React.createElement(FadeUp, {
        shouldAnimate: shouldAnimate
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.responseListContainer
      }, children(classes), /*#__PURE__*/React.createElement("div", {
        className: classes.responseTime
      }, (!animate || animationExited) && /*#__PURE__*/React.createElement(TimePosted, {
        time: created
      }), animate && /*#__PURE__*/React.createElement(Fade, {
        in: !animationComplete ? true : false,
        timeout: {
          enter: 1000,
          exit: 800
        },
        onEntered: this.handleAnimationCompleted,
        onExited: this.handleAnimationExit,
        appear: shouldAnimate,
        unmountOnExit: true
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "caption",
        classes: {
          caption: classes.caption
        }
      }, t("Sending..."))))));
    }
  }]);

  return CustomerDialogueWrapper;
}(PureComponent);

var styles = function styles(_ref) {
  var palette = _ref.palette;
  return {
    responseListContainer: {
      paddingTop: 10,
      paddingBottom: 10
    },
    dialogueWrapper: {
      display: "flex"
    },
    responseTime: {
      display: "flex",
      justifyContent: "flex-end",
      marginRight: 5,
      paddingTop: 5
    },
    caption: {
      color: palette.contrast.text
    }
  };
};

export default withStyles(styles)(withi18n(CustomerDialogueWrapper));